import { registerModule, setupModules } from '@/app/module-registry';
import { registerBuiltinFields } from '@/core/forms/fields/builtin';
import { homeModule } from './home';
import { accountModule } from './account';
import { catalogModule } from './catalog';
import { advertiserModule } from './advertiser';
import { checkoutModule, plansModule } from './checkout';
import { adminModule } from './admin';

/**
 * MANIFESTO DE MODULOS
 *
 * Este e o unico arquivo que precisa mudar para acrescentar um modulo ao
 * produto — e a mudanca e uma linha. Rotas, menus e a decisao de subir ou
 * nao ficam dentro do proprio modulo.
 *
 * Para o SOFAZENDA (Cap. 36): mesmo nucleo, outro conjunto de modulos e outro
 * documento de configuracao servido para outro dominio.
 */
export function bootstrapModules(): void {
  registerBuiltinFields();

  registerModule(homeModule);
  registerModule(accountModule);
  registerModule(catalogModule);
  registerModule(advertiserModule);
  registerModule(plansModule);
  registerModule(checkoutModule);
  registerModule(adminModule);

  setupModules();
}
